import React from "react";
import moment from "moment";
import "moment/locale/es";

import { AuthProvider } from "./auth/AuthContext";
import { ContextProviderInfo } from "./context/ContextInfo";
import { AppRoutes } from "./routes/AppRoutes";

import "./index.css";

import "./assets/scss/Saas.scss";

moment.locale("es");

export const MainApp = () => {
  return (
    <AuthProvider>
      <ContextProviderInfo>
        <AppRoutes />
      </ContextProviderInfo>
    </AuthProvider>
  );
};
